<template>
  <v-form ref="inviteWsForm" class="text-center mt-3" @submit.prevent="setInviteWs" lazy-validation>
    <v-container style="background-color: #21343b">
      <v-row>
        <v-col style="color: white; text-align: left !important; font-weight: 700; font-size: 18px">Invite link</v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="pa-0 mr-2">
          <v-switch v-model="showMagicLink"></v-switch>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-text-field
            dark
            color="white"
            type="text"
            readonly
            background-color="#1a272e"
            v-model="wsMagicLink"
            :loading="isMagicLinkLoading"
            solo
            dense
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col style="text-align: left !important">
          <span style="color: #96a7af; font-size: 13px">
            Share this secret link to invite people to this workspace. To reset this link click
            <u @click="setMagicLink(true)" style="cursor: pointer">here</u>
            .
          </span>
        </v-col>
        <v-col cols="auto" class="mt-2 ml-5">
          <v-btn class="link_btn" @click="copy(wsMagicLink)" :disabled="!showMagicLink || isMagicLinkLoading">
            {{ isMobile() ? 'Share' : 'Copy' }} Link
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="color: white; text-align: left !important; font-weight: 700; font-size: 18px">
          Email Invitation
        </v-col>
      </v-row>
      <v-row v-for="n in count" :key="n">
        <v-col class="pt-0 pb-0 mt-0">
          <v-text-field
            dark
            type="email"
            solo
            dense
            height="45px"
            background-color="#1a272e"
            :ref="`email${n - 1}`"
            :placeholder="$t('emailAddress')"
            :rules="[rules.email]"
            hide-details="auto"
            v-model="email[n - 1]"
            @keyup="checkVal(n - 1, $refs[`email${n - 1}`][0].hasError, email[n - 1])"
            @blur="checkVal(n - 1, $refs[`email${n - 1}`][0].hasError, email[n - 1])"
          />
        </v-col>
      </v-row>
      <v-row v-if="count <= max">
        <v-col class="pt-0 pb-0 mt-5 text-center">
          <v-btn text @click="addField">
            <v-icon large color="#666">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0 pb-0 mt-5">
          <v-btn
            block
            elevation="0"
            height="40"
            :disabled="!isBtnAble || isLoading"
            :loading="isLoading"
            :class="'btn-' + (isBtnAble || isLoading ? 'able' : 'disable')"
            id="continue"
            @click="setInviteWs"
          >
            {{ $t('continue') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { isNull, regExpTest, format, isMobile } from '@/common/lib/strLib'
import { setInviteWs, getInviteUrl, setMagicLink, setWsUpdate } from '@/services/api'
import firebase from 'firebase/app'
import { copy } from '@/common/common'
import Toast from '@/views/meeting/component/Toast'

export default {
  name: 'InputEmail',
  props: {
    isDialog: Boolean,
  },
  data() {
    return {
      count: 1,
      max: 5,
      email: [],
      passedWsId: this.$store.getters.selectedWsInfo.wsId,
      valChkArray: [],
      isBtnAble: false,
      isLoading: false,
      showMagicLink: this.$store.getters.selectedWsInfo.wsMagicLinkEnabled ?? false,
      wsMagicLink: this.$store.getters.selectedWsInfo.wsMagicLinkUrl ?? '',
      isMagicLinkLoading: false,
    }
  },

  created() {},

  computed: {
    rules() {
      let vm = this

      return {
        required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        email: (value) => {
          if (value === undefined || value === '' || (value && value.length === 0)) {
            return true
          } else return regExpTest('EMAIL', value) || vm.$t('msgCheckEmailFormat')
        },
      }
    },
  },
  watch: {
    showMagicLink() {
      this.setMagicLink()
    },

    valChkArray: {
      deep: true,
      immediate: true,
      handler() {},
    },
  },
  methods: {
    validateEmail(email) {
      let regExp = /\S+@\S+\.\S+/
      return regExp.test(email)
    },

    isMobile() {
      return isMobile()
    },
    checkVal(index, result, email) {
      this.valChkArray.splice(index, 1, !result)

      if (
        (result === false || email === undefined || email === '') &&
        this.email[0] !== '' &&
        this.email[0] !== undefined
      )
        this.isBtnAble = true
      else if (this.email[0] === '' || this.email[0] === undefined || email !== undefined || email !== '')
        this.isBtnAble = false
    },
    done() {
      this.$emit('done')
    },
    addField() {
      this.count++
      this.valChkArray.push(false)
      // this.isBtnAble = !this.valChkArray.includes(false)
    },
    async setInviteWs() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false
      // if (!this.$refs.inviteWsForm.validate()) return false

      try {
        let userEmail = Array.from(new Set(this.email)).filter(
          (item) => item !== '' && item !== undefined && this.validateEmail(item) !== false
        )

        if (userEmail.length > 0 && userEmail !== undefined) {
          // 초대 API
          let inviteResult = await setInviteWs(this, this.passedWsId, this.$store.getters.userName, userEmail)
          // 리턴 받아온 정보 중 미가입 회원의 email에 로그인 링크 전달
          // 로그인 처리는 하지 않고, 쿼리를 전달받아 처리되도록 처리
          for (let email of inviteResult.nonMembers) {
            await firebase.auth().sendSignInLinkToEmail(email, {
              url: location.origin + '/signup?passedEmail=' + email + '&passedWsId=' + this.passedWsId,
              handleCodeInApp: true,
            })
          }
        }
        // notify(this, 'Success', this.$t('inviteTeammatesDone'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('inviteTeammatesDone'),
            // submsg: '',
          },
        }
        this.$toast.success(content)
        if (this.isDialog) this.$emit('close')
      } catch (error) {
        // notify(this, 'Error', error.message, 'error')
        const content = {
          component: Toast,
          props: {
            msg: error.message,
            // submsg: '',
          },
        }
        this.$toast.error(content)
      } finally {
        this.isLoading = false
      }
    },
    async setMagicLink(isReset = false) {
      this.isMagicLinkLoading = true

      let params = {
        wsMagicLinkEnabled: this.showMagicLink,
      }

      if (this.showMagicLink || isReset) {
        if ((this.$store.getters.selectedWsInfo.wsMagicLinkUrl ?? '') === '' || isReset) {
          params.wsMagicLinkUrl = await this.createMagicLink()
          this.wsMagicLink = params.wsMagicLinkUrl
        } else this.wsMagicLink = this.$store.getters.selectedWsInfo.wsMagicLinkUrl
      } else if (!this.showMagicLink) {
        this.wsMagicLink = ''
      }

      let result = await setWsUpdate(this, this.$store.getters.selectedWsInfo.wsId, params)
      await this.$store.dispatch('getUserWsList')
      const selectedWsInfo = Object.assign({}, this.$store.getters.selectedWsInfo, JSON.parse(result))
      this.$store.commit('setSelectedWsInfo', selectedWsInfo)
      // notify(this, 'Success', this.$t('updateSuccess'), 'success')

      this.isMagicLinkLoading = false
    },
    async createMagicLink() {
      // TODO: 어떻게 쓸지 몰라서 일단은...
      // TODO: 나중에 함수 통합 필요
      let title = format(this.$t('magicLinkTitle'), [this.$store.getters.selectedWsInfo.wsName])
      let content = format(this.$t('magicLinkContent'), [
        this.$store.getters.userInfo.userDisplayName || this.$store.getters.userInfo.userFullName,
        this.$store.getters.selectedWsInfo.wsName,
      ])
      let imgUrl = this.$store.getters.selectedWsInfo.wsLogo ?? 'https://tape.ooo/img/tape_og_img.png'

      let setMagicLinkResult = await setMagicLink(this, this.$store.getters.selectedWsInfo.wsId)
      let linkUrl =
        location.origin +
        '/invite?passedWsId=' +
        this.$store.getters.selectedWsInfo.wsId +
        '&magicLinkCode=' +
        setMagicLinkResult.magicLinkCode

      let getInviteUrlResult = await getInviteUrl(this, title, content, imgUrl, linkUrl)

      return getInviteUrlResult.shortLink
    },
    async copy(url) {
      let copyResult = await copy(url)
      if (copyResult) {
        if (!this.isMobile()) {
          // notify(this, 'Success', this.$t('copiedClipboardUrl'), 'success')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('copiedClipboardUrl'),
              // submsg: '',
            },
          }
          this.$toast.success(content)
        }
        // TODO: analytics 추가
        // this.$analytics.logEvent('', { name: '', methodType: '' })
      } else {
        // notify(this, 'Error', this.$t('failedCopy'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('failedCopy'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
      }
    },
  },
}
</script>

<style scoped></style>
